/** Sentinel focus key for the combined chart's leading "All" tab — every series renders active (purple). */
export const ALL_SERIES_KEY = '__all__';
